import { useState } from "react";
import { Info, X } from "@phosphor-icons/react";

/**
 * Tiny info icon that reveals a short tooltip on hover (desktop) or click (mobile).
 *
 *   <HelpHint text="Trackers are reusable topics tracked over multiple waves." />
 *
 * Pair with a label:
 *   <Label className="flex items-center gap-1">Tracker name <HelpHint text="..." /></Label>
 */
export default function HelpHint({ text, size = 13, side = "right", testid }) {
  const [open, setOpen] = useState(false);
  const pos = {
    right: "left-full ml-2 top-1/2 -translate-y-1/2",
    left: "right-full mr-2 top-1/2 -translate-y-1/2",
    top: "bottom-full mb-2 left-1/2 -translate-x-1/2",
    bottom: "top-full mt-2 left-1/2 -translate-x-1/2",
  }[side] || "left-full ml-2 top-1/2 -translate-y-1/2";

  return (
    <span className="relative inline-flex" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="text-neutral-400 hover:text-mango focus:outline-none focus:text-mango"
        aria-label="More info"
        data-testid={testid || "help-hint"}
      >
        <Info size={size} weight="fill" />
      </button>
      {open && (
        <span className={`absolute z-50 ${pos} w-64 p-3 bg-black text-white text-xs leading-relaxed shadow-xl border border-mango/40 normal-case tracking-normal font-normal`}>
          <span className="flex items-start justify-between gap-2">
            <span>{text}</span>
            <button type="button" onClick={(e) => { e.stopPropagation(); setOpen(false); }} className="text-neutral-400 hover:text-white"><X size={12} /></button>
          </span>
        </span>
      )}
    </span>
  );
}
